// -------------------------------------------------------------------------
// MARK: Default Data for Receipt page
//  Needed to set default data for the receipts page to be able to process
//  information for display in CMS.
// -------------------------------------------------------------------------
export const DEFAULT_RECEIPT_ID = "12345";

const receiptDefaultValues = {
    receipt: {
        feeCoverage: 5,
        total: 0,
        transaction: {
            address: "123 Testing Road",
            allQrCodesGenerated: true,
            amount: 70,
            anonymous: "n",
            bill_address: "123 Testing Road",
            bill_city: "Testing City",
            bill_country: "US",
            bill_state: "FL",
            bill_zip: 33809,
            ccLastFour: 1111,
            ccName: "John Doe",
            ccType: "VS",
            checkNumber: "",
            city: "Testing City",
            company: "",
            country: "US",
            creatingTransactionFor: 0, // no idea what this means
            date: "2021-04-26",
            dedication_fields: [],
            demo: "y",
            donations: [
                {
                    amount: 50,
                    amountName: "",
                    checkNumber: "",
                    classification: "",
                    contactViaEmail: 1,
                    dedName: "",
                    dedRecipients: "",
                    dedText: "",
                    directCost: 0,
                    donor: 56798,
                    entity: 1,
                    entityType: 10,
                    form: 10417,
                    id: 326692,
                    isPledge: 0,
                    matchingDonation: "",
                    matchingDonationId: "",
                    message: "",
                    numberInSequence: 0,
                    offlineStatus: "",
                    offlineType: "",
                    org: 18419,
                    originalAmount: 50,
                    pledge: 0,
                    recurring: 0,
                    restriction: "",
                    restrictionId: 0,
                    showAmount: 1,
                    showName: 1,
                    source: 3,
                    status: 1,
                    subRestriction: "",
                    transaction: 465712,
                },
            ],
            email: "john_doe@test.com",
            fields: [],
            fname: "John",
            form: 10417,
            id: 465704,
            lname: "Doe",
            optin: "",
            org: 18419,
            phone: 1234567890,
            qrCodeUrl: '',
            qrCodeCount: 1,
            receiptId: DEFAULT_RECEIPT_ID,
            registrations: [
                {
                    activityRole: 1,
                    categoryName: "Category Name",
                    classificationName: "Classification Name",
                    email: "john_doe@test.com",
                    firstName: "John",
                    id: 1,
                    lastName: "Doe",
                    parentRegistration: 0,
                    participantTotal: 70,
                    teamCaptain: 0,
                    teamName: "",
                },
            ],
            store: {
                cart: [
                    {
                        attributes: ["Medium", "Blue"],
                        qtySold: 2,
                        title: "T-Shirt",
                        itemTotalCost: 20,
                        unitCost: 10,
                    },
                ],
                totalCost: 23.80,
                amountBeforeTaxAndShipping: 20,
                totalTaxAmount: 1.3,
                shippingMethodCost: 2.5,
                shippingMethodName: "Standard",
                shippingMethodDescription: "2-3 days",
                shippingContact: {
                    fname: "John",
                    lname: "Doe",
                    address: "123 Testing Road",
                    city: "Testing City",
                    country: "US",
                    state: "FL",
                    zip: 33809,
                },
            },
            salutation: "",
            source: "p2p",
            state: "FL",
            status: "active",
            tm_stamp: "2021-04-26 10:10:15",
            zip: 33809,
        },
    },
};

export default receiptDefaultValues;
